import Drawable from "_src/engine/drawable";

export default {
  createDrawable(shader) {
    return new Drawable(shader);
  }
}
